module.exports = __webpack_public_path__ + "static/media/background-9.9bd049a1.jpg";